// extracted by mini-css-extract-plugin
export var boxItems = "_7s-1";
export var boxItemsLg = "_7s-2";
export var button = "_7s-7";
export var buttonLg = "_7s-8";
export var filterGroupBox = "_7s-0";
export var icon = "_7s-3";
export var iconSecondary = "_7s-6";
export var iconWrapper = "_7s-4";
export var iconWrapperLg = "_7s-5";